export default __webpack_public_path__ + "static/media/visitlogo.9654c8e2.svg";